import React, { useState } from 'react';
import { Stepper } from 'react-form-stepper';
import PageHeader from "../../components/PageHeader";
import IdentifyInformationStep from './Steps/IdentifyInformationStep';
import AccountInformationStep from './Steps/AccountInformationStep';
import AddressInformationStep from './Steps/AddressInformation';
import CreditInformationStep from './Steps/CreditInformationStep';
import PasswordInformationStep from './Steps/PasswordInformationStep';
import {Button, Form} from "react-bootstrap";

const CreateIdentifyPage = () => {
    const [activeStep, setActiveStep] = useState(0);

    const stepForm = [
        {
            id: 1,
            component: (
                <IdentifyInformationStep activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        {
            id: 2,
            component: (
                <AccountInformationStep activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        {
            id: 2,
            component: (
                <AddressInformationStep activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        {
            id: 4,
            component: (
                <CreditInformationStep activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        {
            id: 5,
            component: (
                <PasswordInformationStep activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        // { id: 4, component: <StepOne activeStep={activeStep} /> },
    ];
    return (
        <>
            <PageHeader name="Create Identify" />
            <div>
                <div className="row justify-content-center">
                    <div className="col-xl-10">
                        <div className="card custom-card">
                            <div className="card-body">
                                <div className="single-step mt-4">
                                    <h5 className="">Identify Information</h5>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Name:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Name" />
                                            </Form.Group>
                                        </div>

                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Email:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Email" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Phone Number:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Phone Number" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Gender:</Form.Label>
                                                <Form.Select aria-label="Gender">
                                                    <option value="Male">Male</option>
                                                    <option value="Female">Female</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </div>
                                    </div>
                                </div>
                                <div className="single-step mt-4">
                                    <h5 className="text-start">Account Information</h5>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Identify Owner:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Identify Owner" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>ID Upload:</Form.Label>
                                                <Form.Control type="file" placeholder="Enter " />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Real/Fake:</Form.Label>
                                                <Form.Control type="text" placeholder="Real/Fake" />
                                            </Form.Group>
                                        </div>
                                    </div>
                                </div>
                                <div className="single-step mt-4">
                                    <h5 className="text-start">Address Information</h5>

                                    <div className="row">
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Street Address:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Street Address" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Appt Number:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Appt Number" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>City:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter City" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>State:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter State" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Zip Code:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Zip Code" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Metro Area:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Metro Area" />
                                            </Form.Group>
                                        </div>
                                    </div>
                                </div>
                                <div className="single-step mt-4">
                                    <h5 className="text-start">Credit Information</h5>

                                    <div className="row">
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Credit Type:</Form.Label>
                                                <Form.Control type="text" placeholder="Visa" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>CCV#</Form.Label>
                                                <Form.Control type="text" placeholder="123456789" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>EXP:</Form.Label>
                                                <Form.Control type="date" placeholder="12/26" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Security Code:</Form.Label>
                                                <Form.Control type="text" placeholder="123" />
                                            </Form.Group>
                                        </div>
                                    </div>
                                </div>
                                <div className="single-step mt-4">
                                    <h5 className="text-start">Password Information</h5>

                                    <div className="row">
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Ticket Master:</Form.Label>
                                                <Form.Control type="text" placeholder="Password123" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Gmail:</Form.Label>
                                                <Form.Control type="text" placeholder="Password123!" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>AXS:</Form.Label>
                                                <Form.Control type="text" placeholder="Password1" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Seatgeek:</Form.Label>
                                                <Form.Control type="text" placeholder="Password@123" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>MLB Ballpark:</Form.Label>
                                                <Form.Control type="text" placeholder="Password13" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Paciolan:</Form.Label>
                                                <Form.Control type="text" placeholder="Password123" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Other:</Form.Label>
                                                <Form.Control type="text" placeholder="Password" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-12 mt-5">
                                            <div className="row justify-content-end">
                                                <div className="col-lg-3 d-flex mb-3">
                                                    <Button
                                                        variant="primary"
                                                        className="text-white mt-auto w-100"
                                                    >
                                                        Previous
                                                    </Button>
                                                </div>
                                                <div className="col-lg-3 d-flex mb-3">
                                                    <Button
                                                        variant="primary"
                                                        className="text-white mt-auto w-100"
                                                    >
                                                        Save
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <Stepper
                    steps={[{ label: 'Identify Information' }, { label: 'Account Information' }, { label: 'Address Information' }, { label: 'Credit Information' }, { label: 'Password Information' }]}
                    styleConfig={{
                        activeBgColor: "rgba(45, 51, 61, 0.6)",
                        activeTextColor: "#fff",
                        inactiveBgColor: "#fff",
                        inactiveTextColor: "#999",
                        completedBgColor: "rgb(45, 51, 61)",
                        completedTextColor: "#fff",
                        size: "2em",
                    }}
                    activeStep={activeStep+1}
                /> */}
            </div>

            {/* {stepForm[activeStep].component} */}

        </>
    );
};

export default CreateIdentifyPage;